<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editTariffZone">
        <div class="row">
          <!-- Checkboxes en haut -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="isDefault" type="checkbox" class="form-check-input" id="isDefault"
                  v-model="formData.isDefault" />
                <label class="form-check-label text-black fw-semibold" for="isDefault">
                  Zone par défaut
                </label>
              </div>
              <ErrorMessage name="isDefault" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="isActive" type="checkbox" class="form-check-input" id="isActive"
                  v-model="formData.isActive" />
                <label class="form-check-label text-black fw-semibold" for="isActive">
                  Active
                </label>
              </div>
              <ErrorMessage name="isActive" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4"></div>

          <!-- Code et Nom -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le code" v-model="formData.code" />
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" v-model="formData.name" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>

          <!-- Continent(s) - OBLIGATOIRE -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Continent(s) d'origine du chargement <span class="text-danger">*</span>
              </label>
              <Field name="continent">
                <Multiselect v-model="formData.continent" :options="continentOptions" :searchable="false" mode="tags"
                  track-by="value" label="label" placeholder="Sélectionnez un ou plusieurs continents" />
              </Field>
              <ErrorMessage name="continent" class="text-danger" />
              <small class="text-muted">Sélectionnez tous les continents concernés par cette zone</small>
            </div>
          </div>

          <!-- Pays - OPTIONNEL -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pays</label>
              <Multiselect
                v-model="formData.paysId"
                :options="paysOptions"
                :searchable="true"
                :multiple="false"
                value-prop="value"         
                track-by="value"
                label="label"
                placeholder="Sélectionner le pays"
              />
              <ErrorMessage name="paysId" class="text-danger" />
              <small class="text-muted">Optionnel - Laissez vide pour tous les pays</small>
            </div>
          </div>

          <!-- Port - OPTIONNEL -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Port</label>
              <Multiselect
                v-model="formData.portId"
                :options="ports"
                :searchable="true"
                :loading="loadingPorts"
                placeholder="Rechercher (nomPort ou locode)..."
                label="label"
                track-by="value"
                value-prop="value"
                @search-change="searchPort"
                :filter-results="false"
                :min-chars="2"
              />
              <ErrorMessage name="portId" class="text-danger" />
              <small class="text-muted">Optionnel - Laissez vide pour tous les ports</small>
            </div>
          </div>

          <!-- Dates -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Date de début</label>
              <Field name="effectiveFrom" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.effectiveFrom" />
              <ErrorMessage name="effectiveFrom" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Date de fin</label>
              <Field name="effectiveTo" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.effectiveTo" />
              <ErrorMessage name="effectiveTo" class="text-danger" />
            </div>
          </div>

          <!-- Description -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Description</label>
              <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.description" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>

          <!-- Boutons -->
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Modifier
              </button>
              <router-link to="/listeTariffZone" class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted, nextTick } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import Multiselect from '@vueform/multiselect';
import ApiService from "@/services/ApiService";
import { error, success } from "@/utils/utils";

export default defineComponent({
  name: "EditTariffZone",
  components: { Form, Field, ErrorMessage, Multiselect },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const zoneId = route.params.id as string;

    const tariffZoneSchema = Yup.object().shape({
      code: Yup.string().required("Le code est obligatoire"),
      name: Yup.string().required("Le nom est obligatoire"),
      continent: Yup.array()
        .of(Yup.string().oneOf(['AFRIQUE', 'EUROPE', 'ASIE', 'AMERIQUE', 'OCEANIE']))
        .min(1, 'Au moins un continent est obligatoire')
        .required('Le(s) continent(s) sont obligatoires'),
    });

    const paysOptions = ref<{ value: number; label: string }[]>([]);
    const ports = ref<{ value: number; label: string }[]>([]);
    const loadingPorts = ref(false);
    const continentOptions = ref([
      { value: 'AFRIQUE', label: 'Afrique' },
      { value: 'EUROPE', label: 'Europe' },
      { value: 'ASIE', label: 'Asie' },
      { value: 'AMERIQUE', label: 'Amérique' },
      { value: 'OCEANIE', label: 'Océanie' },
    ]);
    let searchTimeout: ReturnType<typeof setTimeout> | null = null;

    const formData = reactive({
      code: "",
      name: "",
      description: "",
      isDefault: false,
      isActive: true,
      continent: [] as string[],
      paysId: null as number | null,
      portId: null as number | null,
      effectiveFrom: null as string | null,
      effectiveTo: null as string | null,
    });

    const fetchPays = async () => {
      try {
        const response = await ApiService.get('/pays?limit=0');
        const paysData = response.data.data.data;
        paysOptions.value = paysData.map((p: any) => ({
          value: p.id,
          label: `${p.iso2_code} - ${p.name_fr}`,
        }));
      } catch (err) {
        console.error("Erreur chargement pays", err);
      }
    };

    // const searchPort = async (query: string) => {
    //   if (searchTimeout) clearTimeout(searchTimeout);

    //   if (!query || query.length < 2) {
    //     ports.value = [];
    //     return;
    //   }

    //   searchTimeout = setTimeout(async () => {
    //     loadingPorts.value = true;
    //     try {
    //       const response = await ApiService.get(`/Liste/port?search=${encodeURIComponent(query)}`);
    //       const portsData = response.data?.data || [];
    //       ports.value = portsData.map((p: any) => ({
    //         value: p.id,
    //         label: `${p.nomPort} - ${p.locode}`,
    //       }));
    //     } catch (err) {
    //       ports.value = [];
    //     } finally {
    //       loadingPorts.value = false;
    //     }
    //   }, 300);
    // };


    const searchPort = async (query: string) => {
      if (searchTimeout) {
        clearTimeout(searchTimeout)
      }

      if (!query || query.length < 2) {
        ports.value = []
        return
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true

        try {
          const response = await ApiService.get(`/Liste/port?search=${encodeURIComponent(query)}`)
          const portsData = response.data?.data || []

          ports.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id
          }))

        } catch (err: any) {
          console.error('Erreur recherche ports:', err)
          error('Impossible de rechercher les ports')
          ports.value = []
        } finally {
          loadingPorts.value = false
        }
      }, 300)
    }

    const getTariffZone = async (id: string) => {
      console.log("Valeur paysId chargée :", formData.paysId);
      console.log("Liste paysOptions :", paysOptions.value.map(o => o.value));
      try {
        const response = await ApiService.get(`/tariff-zone/${id}`);
        const zone = response.data.data;
        console.log("zoneeeeeeeeee", response.data.data)
        formData.code = zone.code || "";
        formData.name = zone.name || "";
        formData.description = zone.description || "";
        formData.isDefault = zone.isDefault || false;
        formData.isActive = zone.isActive ?? true;
        formData.continent = zone.continent || [];
        formData.effectiveFrom = zone.effectiveFrom || null;
        formData.effectiveTo = zone.effectiveTo || null;
        formData.paysId = zone.pays?.id ?? null;
        formData.portId  = zone.port?.id  ?? null;
        if (zone.port) {
          ports.value = [{
            value: zone.port.id,
            label: `${zone.port.nomPort} - ${zone.port.locode || 'LOCODE inconnu'}`
          }];
        }

        await nextTick();
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement de la zone");
        router.push("/listeTariffZone");
      }
    };

    const editTariffZone = async () => {
      try {
        const payload = {
          code: formData.code,
          name: formData.name,
          description: formData.description,
          isDefault: formData.isDefault,
          isActive: formData.isActive,
          continent: formData.continent,
          paysId: formData.paysId ?? null,   
          portId:  formData.portId  ?? null,
          effectiveFrom: formData.effectiveFrom,
          effectiveTo: formData.effectiveTo,
        };

        console.log(' Payload envoyé:', payload);

        await ApiService.put(`/tariff-zone/${zoneId}`, payload);
        success("Zone tarifaire modifiée avec succès !");
        router.push("/listeTariffZone");
      } catch (err: any) {
        error(err.response?.data?.message || "Échec de la modification");
      }
    };

    onMounted(async () => {
      await fetchPays();       
      await getTariffZone(zoneId);
    });

    return {
      formData,
      tariffZoneSchema,
      editTariffZone,
      paysOptions,
      continentOptions,
      ports,
      loadingPorts,
      searchPort,
    };
  },
});
</script>